export default {
  //API_URLV2: "https://api.bikeregistrada.com.br", //Prod Nova Api
  API_URLV2: "https://apim-bikeregistrada.azure-api.net", //Prod Nova Api
  IUGU_TEST_MODE: false,
  TOKEN: "6LeXQmkpAAAAAD6DDL7r0o3uk9v5pJJw5Ykjdu2l",
};
